// extracted by mini-css-extract-plugin
module.exports = {"btn-submit":"formRegister_btn-submit__3i9Yb","form":"formRegister_form__1Ndmt","field-group":"formRegister_field-group__3M4dE","terminos":"formRegister_terminos__ZBpJD"};